import detect from '../../core/detect'
import Hero from './Hero';
import ScrollAnimation from './ScrollAnimation';
import Price from './Price';
import ColumnSlider from './ColumnSlider';

export default class Home {
  constructor() {
    new Hero();
    new ScrollAnimation();
    new Price();
    new ColumnSlider();

    if (!detect.isMobile()) {
      ScrollTrigger.normalizeScroll(true);
    }
  }
}
